import React, {Component} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './styles/GraduateModal.css';

class VideoModal extends Component {
    render() {
        return (
            <div className={'container'}>
                <div className={'grid grid--modal'}>
                    <div className={'col--12'}>
                        <iframe title={'Promo Video'} width="100%" height="100%" src="https://www.youtube.com/embed/oxJ3ZULhRpQ"
                                frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
                        </iframe>
                        <div className={'modal__close'}>
                            <div className={'modal__close-button'} onClick={this.props.closeModal}>
                                <FontAwesomeIcon className={'icon'} icon={'times'}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoModal;